import { PTTMessage } from '../../../../../pttDispatcher/api/usePttMessageStore';
import { File } from '../../../../../../../types/File';

export function isPTTMessage(item: File | PTTMessage): item is PTTMessage {
    return 'fileUrl' in item;
}
